<template>
  <div class='flex flex-col'>
      <div v-for="(cp, index) in consultations" :key="index" @click="selectFromPastList(cp.consultation.consultationId, cp.consultationRequest.consultationRequestId)"
        v-bind:class="(cp.consultationRequest.consultationRequestId === activePastConsultationRequestId) ? 'bg-grey-extralight' : ''"
        class="flex flex-col px-3 px-3 py-4 flex-no-shrink flex-no-grow border-b border-solid border-grey-lightest cursor-pointer hover:bg-grey-extralight">
          <div class="flex flex-row justify-between mb-2 h-4">
            <div class="flex flex-col">
              <div class="flex items-center h-4">
                <div class="text-sm font-semibold text-grey-darkest capitalize">{{cp.name}}</div>
              </div>
            </div>
              <div v-if="cp.isFamilyDoctor"><img src="../../assets/personal_patient.svg" alt="Personal Patient" style="width:20px; height:20px"></div>
          </div>
          <div class="flex flex-row h-4">
            <div v-if="consultStatus(cp)" class="text-xs font-semibold text-green-light font-light">Case Closed</div>
            <div v-else class="text-xs font-semibold text-red-light font-light">Summary Pending</div>
            <div class="text-xs ml-auto text-grey-dark font-light">{{cp.consultationRequest.date | formatDate}}</div>
          </div>
      </div>
      <div v-if="showLoadMore" class="flex flex-col h-12 justify-center">
          <div @click="fetchMoreConsults" class="flex px-3 py-1 justify-end cursor-pointer italic rounded-sm text-blue text-sm hover:text-grey-darker">
            Load more . . .
          </div>
      </div>
      <UnsavedChangesModal v-if="showSaveReminder" @close='closeModal'/>
  </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import UnsavedChangesModal from '@/components/common/modals/UnsavedChanges'
export default {
  components: {
    UnsavedChangesModal
  },
  data () {
    return {
      search: '',
      viewProfile: false,
      showSaveReminder: false
    }
  },
  computed: {
    ...mapState({
      activePastConsult: state => state.pastConsultation.activePastConsultId,
      activePastConsultationRequestId: state => state.pastConsultation.activePastConsultationRequestId,
      editTextField: state => state.textField.inEdit
    }),
    ...mapGetters({
      consultations: 'pastConsultation/getPastConsults',
      showLoadMore: 'pastConsultation/showLoadMore'
    })
  },
  watch: {
    consultations: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.consultations = newVal
      }
    }
  },
  methods: {
    selectFromPastList: function (id, consultationRequestId) {
      if (this.editTextField) {
        this.showSaveReminder = true
        return
      }
      this.$store.dispatch('pastConsultation/switchTo', {id, consultationRequestId})
    },
    consultStatus: function (cp) {
      if (cp.consultation.consultationId === null || cp.consultation.consultationId === undefined) {
        return true
      } else {
        if (cp.consultation.summary_status === 'done' || cp.consultation.summary_status === 'not_needed') {
          return true
        } else {
          return false
        }
      }
    },
    viewCustomerProfile: function (e) {
      e.stopPropagation()
      this.viewProfile = !this.viewProfile
    },
    fetchMoreConsults: function () {
      this.$store.dispatch('pastConsultation/fetchMoreConsults')
    },
    closeModal: function (params) {
      this.showSaveReminder = false
    }
  }
}
</script>

<style>
.isActive {
  background-color: #dae1e7
}

</style>



// WEBPACK FOOTER //
// src/components/Consultations/PastConsultations.vue